import { Component, OnInit, Input, Output, EventEmitter } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, Validators } from '@angular/forms';

import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
declare var require;
const Swal = require('sweetalert2');

import { getErrorMesage } from '@helpers/functions';
import { Validations } from '@helpers/validations';

import { APP_CONFIG } from '@config/config';
import { CONFIG, Perfil } from '../../usuarios';

import { UsuariosService } from '../../usuarios.service';
import { AccountService } from '../../../../../services/account.service';

@Component({
    selector: 'app-usuario-cambiar-password',
    templateUrl: './usuario-cambiar-password.component.html',
    styleUrls: ['./usuario-cambiar-password.component.scss']
})
export class UsuarioCambiarPasswordComponent implements OnInit {
    id: null|number;
    usuarioId: number;
    // Variables  de config
    botones: any = [];
    mensajes_app: any = [];
    titulos: any = [];
    mensajes: any = [];
    campos: any = [];
    // Variables de estados
    loading: boolean = false;
    // Variables del formulario
    frmPerfil: FormGroup;
    perfil: Perfil;
    titulo: string;

    show1: boolean = false;
    show2: boolean = false;
    show3: boolean = false;

    // Variables de ventana modal
    @Output() recargarDT: EventEmitter<any> = new EventEmitter();

    get fcampos() { return this.frmPerfil.controls; }
    
    constructor(
        private formBuilder: FormBuilder,
        private usuariosService: UsuariosService,
        public activeModal: NgbActiveModal,
        private accountService: AccountService
    ) {
        this.usuarioId = this.usuariosService.usuarioId;

        this.botones = APP_CONFIG.botones;
        this.mensajes_app = APP_CONFIG.mensajes;

        this.titulos = CONFIG.titulos;
        this.mensajes = CONFIG.mensajes;
        this.campos = CONFIG.campos_perfil;
    }

    ngOnInit(): void {
        this.frmPerfil = this.formBuilder.group({
            id: null,
            name: [{ value: null, disabled: true }, [Validators.required]],
            username: [{ value: null, disabled: true }, [Validators.required]],
            email: [{ value: null, disabled: true }, [Validators.required]],
            password_actual: [{ value: null, disabled: false }, [Validators.required, Validators.maxLength(20)]],
            password: [{ value: null, disabled: false }, [Validators.required, Validators.minLength(6), Validators.maxLength(20)]],
            password_confirmation: [{ value: null, disabled: false }, [Validators.required]]
        }, { validators: Validations.passwordMatchValidator });

        let account = this.accountService.accountValue;

        this.id = account.id;
        this.fcampos.id.setValue(account.id);
        this.fcampos.name.setValue(account.name);
        this.fcampos.username.setValue(account.username);
        this.fcampos.email.setValue(account.email);

        this.titulo = 'Cambiar Contraseña';
    }

    guardar(): void {
        let msjPregunta: string;

        msjPregunta = 'Seguro de cambiar la contraseña.';

        if (this.frmPerfil.invalid)
            return;

        Swal.fire({
            icon: 'question',
            title: this.mensajes_app.pregunta.titulo,
            html: msjPregunta,
            showCancelButton: true,
            confirmButtonText: 'Si',
            cancelButtonText: 'No'
        })
        .then((result: any) => {
            if (result.value) {
                this.enviarGuardar();
            }
        });
    }

    enviarGuardar(): void {
        let msjResp_ok: string;

        msjResp_ok = 'La contraseña fue cambiada con éxito.<p>Ahora puede iniciar sesión con la nueva contraseña.</p>';

        this.loading = true;

        this.perfil = this.frmPerfil.getRawValue();

        Swal.fire({
            icon: 'info',
            title: this.mensajes_app.enviando.titulo,
            html: this.mensajes_app.enviando.texto,
            allowOutsideClick: false,
            allowEscapeKey: false
        });
        Swal.showLoading();

        this.usuariosService.cambiarPassword(this.id, this.perfil)
        .subscribe({
            next: (resp: any) => {
                this.loading = false;

                this.id = resp.data.id;
                this.fcampos.id.setValue(this.id);

                this.validarCampos();

                this.activeModal.close();
                this.accountService.logout();

                Swal.fire({
                    icon: 'success',
                    title: this.mensajes_app.respuesta_ok.titulo,
                    html: msjResp_ok
                });
            },
            error: (err: any) => {
                this.loading = false;

                Swal.fire({
                    icon: 'error',
                    title: this.mensajes_app.respuesta_err.titulo
                });
                Swal.showValidationMessage(
                    getErrorMesage(err)
                )
            }
        });
    }

    salir(): void {
        this.activeModal.close();
    }

    validarCampos(): void {
    }

    validarPermisos(): void {
    }

    showPassword1(){
        this.show1 = !this.show1;
    }

    showPassword2(){
        this.show2 = !this.show2;
    }

    showPassword3(){
        this.show3 = !this.show3;
    }

}
